function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m.5 6.07v5.93c0 .72.58 1.3 1.3 1.3h11.4c.72 0 1.3-.58 1.3-1.3v-5.93c0-.41-.19-.79-.52-1.04l-5.7-4.27c-.46-.35-1.1-.35-1.56 0l-5.7 4.28c-.33.25-.52.63-.52 1.04zm7 2.42-4.08-3.06 3.3-2.48c.46-.35 1.1-.35 1.56 0l3.3 2.48z",
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 15 13.8"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/list-outlined.3beacac3.svg";
export { SvgComponent as ReactComponent };